import { Flex } from '@applyboard/crystal-ui';

import { GradeConversionCreateHeading } from '../components/GradeConversionCreateHeading';
import { GradeConversionCreateForm } from '../components/GradeConversionCreateForm';
import { GradeConversionCreateLayoutProps } from './types';

export function MobileLayout(props: GradeConversionCreateLayoutProps) {
  return (
    <Flex p={4} gap={4} direction="column">
      <GradeConversionCreateHeading />
      <GradeConversionCreateForm {...props} />
    </Flex>
  );
}
